import { JobRow } from './JobRow';
import React from "react";

export const Extras = React.memo(function Extras({bookingExtras}) {
    if (bookingExtras.length < 1) {
        return '';
    }

    let validExtras = [];
    for (const bookingExtra of bookingExtras) {
        if (bookingExtra.configuration.visibletoowner && bookingExtra.cancelleddatetime.length < 1) {
            validExtras.push({
                code: bookingExtra.extra.extracode,
                description: bookingExtra.extra.description
            });
        }
    }

    if (validExtras.length < 1) {
        return '';
    }

    const info = validExtras.map((rt, i) => {
        return (
            <div key={ i }>
                { rt.code } - { rt.description }
            </div>
        );
    })

    return <JobRow label="Extras" value={info} />
});